<template>
    <v-card class="card-container">
        <v-card-title >
            <v-row no-gutters class="px-4 py-0">
                <v-col>
                    <span class="bonus-count-label">Активировано: </span><span class="bonus-count-info">{{allBonusesCount}}</span>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 px-6" style="overflow-y: scroll">
            <v-container fluid class="h-100 px-4 py-0">
                <v-row no-gutters class="h-100">
                    <v-col class="py-5" xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-row class="bonus-item mt-2" v-for="item in bonusItems">
                        <v-col class="bonus-item_name">
                            <div >{{item.bonusName}}</div>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="bonus-item_count">
                            <div >{{item.bonusUses}}/{{item.bonusCount}}</div>
                        </v-col>
                    </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "ClientInfoBonuses",
        props:{
            item:Object,

        },
        data(){
            return {

            }
        },
        mounted(){
            this.$store.dispatch("Clients/getClientBonuses", this.item.id).catch(err=>{
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка активаций!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })
        },
        computed:{
            bonusItems(){
                return this.$store.state.Clients.bonuses
            },

            allBonusesCount(){
                if(this.bonusItems.length>0){
                    const initValue=0
                    let usesCount= this.bonusItems.reduce(
                        (acc, curr)=>acc+curr.bonusUses, initValue)
                    let allCount= this.bonusItems.reduce(
                        (acc, curr)=>acc+curr.bonusCount, initValue)
                    return `${usesCount}/${allCount}`
                }
                else return '0/0'
            }

        }
    }
</script>

<style scoped>
    .bonus-item{
        background-color: #F5F7FD;
        padding: 10px;
    }
    .bonus-item_count{
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        text-align: center;
        color: #000000;
    }
    .bonus-count-label {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;

    }

        .bonus-count-info {
            font-weight: 600;
            font-size: 24px;
            line-height: 40px;
            color: #000000;
        }
</style>